import { useLocation } from "react-router-dom";
import LetterDrafter, { type LetterPrefill } from "../components/LetterDrafter";

/**
 * LetterPage — eigenständige Brief-Drafter-Seite.
 * Funktioniert auch ohne vorherige Mock-Jury — User kann direkt einen Brief
 * entwerfen lassen, wenn er schon weiß was er braucht.
 *
 * Sprint I/2 (2026-04-29): Empfängt optional `state.prefill` von
 * B2CAdvisor.SuggestedLetterCTA — wenn vorhanden, übergibt es als
 * `initialPrefill` an LetterDrafter, damit Brief-Typ und Sachverhalt
 * vorausgewählt sind.
 */
export default function LetterPage() {
  const location = useLocation();
  const prefill = (location.state as { prefill?: LetterPrefill } | null)?.prefill;

  return (
    <div className="space-y-6">
      <header>
        <div className="flex items-baseline justify-between flex-wrap gap-2">
          <h1 className="text-3xl font-bold tracking-tight">Brief entwerfen</h1>
          <span className="text-xs text-slate-500">DOCX · sofort druckfertig</span>
        </div>
        <p className="mt-2 text-slate-400 max-w-2xl">
          Wandle deinen Verbraucher-Fall in einen rechtssicheren Schriftsatz: Widerspruch,
          Mahnung, Mietminderung, EU-Fluggastrechte oder Gewährleistung. Die Paragraphen
          sind kuratiert (keine LLM-Halluzinationen).
        </p>
        {prefill && (
          <div className="mt-4 inline-flex items-center gap-2 rounded-full border border-court-600/60 bg-court-900/30 px-3 py-1 text-xs text-court-200">
            <span>✓</span>
            <span>
              Vorausgefüllt aus deinem Mock-Jury-Verdict ({prefill.letterType})
            </span>
          </div>
        )}
      </header>

      <section className="rounded-2xl border border-slate-800 bg-slate-900/40 p-6">
        <LetterDrafter initialPrefill={prefill} />
      </section>

      <div className="rounded-xl border border-slate-800/60 bg-slate-950/40 p-4 text-xs text-slate-500">
        <strong className="text-slate-400">Hinweis nach § 2 RDG:</strong> Shadow Court ist
        keine Anwaltskanzlei. Die generierten Briefe sind Vorlagen-Drafts — bei rechtlich
        komplexen Fällen empfehlen wir die Prüfung durch einen Anwalt.
      </div>
    </div>
  );
}
